import { giphyBlack, giphyIndigo } from '@giphy/colors'
import styled, { css } from 'styled-components'
import { ControlSize } from 'types'
import { borderRadiusFromControlSize, brightnessFromColor, fontSizeFromControlSize, heightFromControlSize } from 'utils'

const baseStyle = css`
    background: inherit;
    border-radius: inherit;
    box-sizing: border-box;
    color: inherit;
    font-size: inherit;
    height: 100%;
    margin: 0;
    padding: 0 1em;
    width: 100%;

    &::placeholder {
        color: inherit;
        opacity: 0.5;
    }

    &::selection {
        background: ${giphyIndigo};
        color: #fff;
    }
`

export const Input = styled.input`
    ${baseStyle}
`

export const Textarea = styled.textarea`
    ${baseStyle}
    resize: none;
`

export const Wrapper = styled.div<{
    controlColor: string
    controlSize: ControlSize
    disabled: boolean
    textColor?: string
}>`
    display: flex;
    flex-direction: row;

    ${({ controlColor, controlSize, textColor }) => {
        const height = heightFromControlSize(controlSize)
        const fontSize = fontSizeFromControlSize(controlSize)
        const lineHeight = Math.round(fontSize * 1.3)
        const padding = Math.floor((height - lineHeight) / 2)

        return css`
            background: ${controlColor};
            border-radius: ${borderRadiusFromControlSize(controlSize)}px;
            color: ${textColor || (brightnessFromColor(controlColor) > 0.5 ? giphyBlack : '#fff')};
            font-size: ${fontSize}px;

            input {
                height: ${height}px;
            }

            textarea {
                line-height: ${lineHeight}px;
                min-height: ${height}px;
                padding-bottom: ${padding}px;
                padding-top: ${padding}px;
            }
        `
    }}

    textarea + button {
        height: 100%;
    }

    ${({ disabled }) =>
        disabled &&
        css`
            opacity: 0.5;
            pointer-events: none;
        `}
`
